import { getTimeEntriesOfClient } from "./getTimeEntriesOfClient";

export function getLastTimeSeenClient(clientId, successCb, failCb) {
  getTimeEntriesOfClient(
    clientId,
    (response) => {
      if (!response.length) {
        failCb("No time entries found for client");
        return;
      }
      let lastTimeSeenClient = response[0].time_entries[0];
      successCb(lastTimeSeenClient);
    },
    (error) => {
      // retry

      setTimeout(() => {
        getLastTimeSeenClient(clientId, successCb, failCb);
        console.log("Retrying...");
      }, 1000);
    }
  );
}
